import React from 'react';

const RequiredFieldIndicator = () => {
    return <span className='pds-label-required' aria-hidden='true'>
        {' *'}
    </span>;
};

export default RequiredFieldIndicator;